export default "__VITE_ASSET__BN$uNMfb__"